<template>
  <div class="level-2-wrap" :class="{ 'light-theme': light, 'w-0': !l2MenuVisibleForStore }">
    <scrollbar class="level-2-menu">
      <div :class="[
          'd-flex justify-content-between align-items-center title text-truncate pr-3',
          { 'pl-3': !l2MenuVisibleForStore },
        ]">
        <span class="d-flex justify-start" v-if="l2MenuVisibleForStore" :title="getLabel(l2Menu.meta)">{{
          getLabel(l2Menu.meta) }}</span>
        <icon-font :class="['d-flex justify-end', 'title-arrow', 'align-items-center']"
          :type="l2MenuVisibleForStore ? 'icon-tkrcircle-left' : 'icon-tkrcircle-right'" @click="
            $store.commit('setting/SET_L2_MENU_VISIBLE', !l2MenuVisibleForStore)
          " />
      </div>
      <div class="level-3-item" v-for="(citem, cidx) of menus" :key="cidx">
        <div class="group-menu" v-if="citem.submenus">
          <a-divider />
          <div v-show="l2MenuVisibleForStore" class="level-3-group-title text-truncate pr-2"
            :title="getLabel(citem.meta)">
            {{ getLabel(citem.meta) }}
          </div>
          <router-link v-for="(sitem, sidx) of citem.submenus" v-show="showMenu(sitem)" :class="[
              'menu-item d-flex align-items-center text-truncate pr-2',
              { collapse: !l2MenuVisibleForStore },
            ]" :key="sidx" :to="sitem.path" :title="getLabel(sitem.meta)" tag="a" active-class="active">
            <a-tooltip class="menu-item-icon flex-shrink-0 flex-grow-0"
              :title="l2MenuVisibleForStore ? '' : getLabel(sitem.meta)" placement="right">
              <!-- <icon-font :type="'icon-tkrres' + sitem.path.replace(/\//g, '-')" /> -->
              <icon-font :type="getIcon(sitem)" />
            </a-tooltip>
            <span v-if="l2MenuVisibleForStore" class="menu-item-title d-flex ml-2">{{ getLabel(sitem.meta) }}</span>
          </router-link>
        </div>
        <router-link v-else v-show="l2MenuVisibleForStore" class="menu-item text-truncate pr-2" :to="citem.path"
          :title="getLabel(citem.meta)" tag="a" active-class="active">
          {{ getLabel(citem.meta) }}
        </router-link>
      </div>
    </scrollbar>
    <!-- <div class="level-2-menu-collapse" @click="$store.commit('setting/SET_L2_MENU_VISIBLE', !l2MenuVisibleForStore)">
      <div class="level-2-menu-collapse-bg" />
      <div class="level-2-menu-collapse-icon d-flex align-items-center">
        <a-icon type="left" style="font-size: 12px;" v-show="l2MenuVisibleForStore" />
        <a-icon type="right" style="font-size: 12px;" v-show="!l2MenuVisibleForStore" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as R from 'ramda'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'Level2Menu',
  props: {
    l2Menu: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['theme']),
    light () {
      // return this.theme === 'light'
      return true
    },
    menus () {
      const menus = this.l2Menu.menus
      const res = []
      menus.forEach(m2item => {
        const m2 = { ...m2item }
        if (this.showMenu(m2)) {
          if (m2.submenus) {
            let flag = false
            const submenus = []
            m2.submenus.forEach(m3item => {
              if (this.showMenu(m3item)) {
                submenus.push(m3item)
                flag = true
              }
            })
            if (flag) {
              m2.submenus = submenus
              res.push(m2)
            }
          } else {
            res.push(m2)
          }
        }
      })
      return res
    },
    l2MenuVisibleForStore () {
      return this.$store.state.setting.l2MenuVisible
    },
  },
  methods: {
    getIcon (menu) {
      if (menu.meta.icon) {
        return 'icon-tkr' + menu.meta.icon
      }
      if (menu.path?.startsWith('/llm')) {
        const res = menu.path.split('/').splice(2)
        return 'icon-tkrres-' + res.join('-')
      }
      return 'icon-tkrres' + menu.path.replace(/\//g, '-')
    },
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    getMenuHidden (menu) {
      if (!R.isNil(menu.meta.hidden)) {
        if (R.is(Function, menu.meta.hidden)) {
          return menu.meta.hidden(this.userInfo)
        }
        return menu.meta.hidden
      }
      if (!R.isNil(menu.meta.invisible)) {
        if (R.is(Function, menu.meta.invisible)) {
          return menu.meta.invisible(this.userInfo)
        }
        return menu.meta.invisible
      }
      return false
    },
    showMenu (item) {
      const hidden = this.getMenuHidden(item)
      if (R.isNil(item.meta.permission) || R.isEmpty(item.meta.permission)) {
        return !hidden && true
      }
      return !hidden && hasPermission({ key: item.meta.permission })
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../styles/less/theme";

.level-2-wrap {
  position: fixed;
  left: 0;
  width: 160px;
  top: 50px;
  bottom: 0;
  background-color: @sidebar-dark-bg-color;
  box-shadow: 1px 0 6px 0 rgba(165, 192, 207, 0.3);
  z-index: 5;
  transition: width 0.2s ease;
  ::v-deep {
    .scrollbar-wrap {
      overflow-x: hidden;
    }
  }
  &.light-theme {
    background-color: @sidebar-light-bg-color;
    .level-2-menu {
      .title {
        color: #000;
      }
    }
    .level-3-item {
      .level-3-group-title {
        color: #000000;
        font-weight: 500;
      }
      .menu-item {
        .menu-item-title {
          position: relative;
        }
      }
    }
  }
  &.w-0 {
    width: 50px;
  }
}

.level-2-menu {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #fff;
  transition: left 0.2s;
  // padding: 16px 0;
  .title {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 12px;
    margin-top: 12px;
    padding-left: 16px;

    .title-arrow {
      font-size: 20px;
      height: 30px;
      line-height: 30px;
      color: rgb(0, 0, 0, 0.66);
      cursor: pointer;
      opacity: 0.66;
    }
  }
  .ant-divider-horizontal {
    margin: 4px 0;
  }
}
.menu-item-icon {
  text-align: center;
  > i {
    font-size: 14px;
  }
  > a {
    color: @sidebar-light-active-text-color;
  }
}

.level-3-item {
  .group-menu {
    margin-bottom: 10px;
  }
  .level-3-group-title {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 24px;
    padding: 4px 0 4px 16px;
  }
  .menu-item {
    display: block;
    padding: 4px 0 4px 16px;
    font-size: 14px;
    color: @sidebar-dark-text-color;
    position: relative;
    cursor: pointer;

    // &:hover, &.active {
    //   text-decoration: none;
    //   &::after {
    //     position: absolute;
    //     content: '';
    //     width: 6px;
    //     height: 6px;
    //     border-radius: 50%;
    //     position: absolute;
    //     left: 0;
    //     top: 50%;
    //     transform: translate(4px, -50%);
    //     background-color: @primary-color;
    //     overflow: hidden;
    //   }
    // }
    &:hover {
      color: @sidebar-dark-hover-text-color;
      background-color: @sidebar-hover-bg-color;
    }
    &.active {
      color: @sidebar-dark-active-text-color;
      background-color: @sidebar-hover-bg-color;
    }
    &.collapse {
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 18px;
    }
  }
  > .menu-item {
    margin-bottom: 25px;
  }
  & + & {
    > .menu-item {
      margin-top: 25px;
    }
  }
}
</style>
